module.exports = __webpack_public_path__ + "static/img/zt5888339.ee4706fa.png";